import { useForm } from '../../../../hooks/useForm';
import { INPUT_TYPE } from '../../../../constants/types';
import { REBATE_TYPE } from '../../../../Pages/Backoffice/ProducerPayoutConfigPage/Form/interfaces';

export const useEditRebateModal = (updateRebate, handleClose, settings = {}) => {
  const {
    formState,
    formValues,
    handleInputChange,
    handleMultipleInputsChange,
    validateFormInputs,
    resetForm,
  } = useForm(
    {
      rebateType: {
        type: INPUT_TYPE.STRING,
        required: true,
        value: settings.rebateType || REBATE_TYPE.NONE,
      },
      vatStatus: {
        type: INPUT_TYPE.STRING,
        required: ({ rebateType }) => rebateType !== REBATE_TYPE.NONE,
        value: settings.vatStatus || '',
      },
      rebatePercentage: {
        type: INPUT_TYPE.FLOAT,
        minValue: 0,
        maxValue: 20,
        required: ({ rebateType }) => rebateType === REBATE_TYPE.PERCENTAGE,
        value: settings.rebatePercentage || '',
      },
      revenueSharePercentage: {
        type: INPUT_TYPE.FLOAT,
        minValue: 0,
        maxValue: 100,
        required: ({ rebateType }) => rebateType === REBATE_TYPE.REVENUE_SHARE,
        value: settings.revenueSharePercentage || '',
      },
    },
    [settings]
  );

  const handleRebateTypeChange = ({ target: { value } }) => {
    switch (value) {
      case REBATE_TYPE.NONE:
        handleMultipleInputsChange([
          { name: 'rebateType', value },
          { name: 'vatStatus', value: undefined },
          { name: 'rebatePercentage', value: undefined },
          { name: 'revenueSharePercentage', value: undefined },
        ]);
        break;
      case REBATE_TYPE.PERCENTAGE:
        handleMultipleInputsChange([
          { name: 'rebateType', value },
          { name: 'revenueSharePercentage', value: undefined },
        ]);
        break;
      case REBATE_TYPE.REVENUE_SHARE:
        handleMultipleInputsChange([
          { name: 'rebateType', value },
          { name: 'rebatePercentage', value: undefined },
        ]);
        break;
      default:
        break;
    }
  };

  const handleEdit = () => {
    const isFormValid = validateFormInputs();
    if (!isFormValid) return;
    updateRebate(formValues);
    handleClose();
  };

  const handleCancel = () => {
    handleClose();
    resetForm();
  };

  return {
    formState,
    formValues,
    handleInputChange,
    handleRebateTypeChange,
    handleEdit,
    handleCancel,
  };
};
